module.exports = __webpack_public_path__ + "img/icon_logo.94dbf224.svg";